import styled from 'styled-components';
import { infoColor, grayColor } from "~/components/layout/Variables";

export const SubTitle = styled.p`
  font-size: .95rem;
  color: ${() => grayColor};
  margin: .5rem 0.5rem .5rem 0rem;
`;

export const ButtonDivision = styled.div`
  width: 50%;
  margin: 1rem auto 1rem auto;

  @media(max-width: 600px) {
    width: 100%;
  }
`;

export const CardBody = styled.div`
  font-weight: 500;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
  justify-content: center;
`;

export const CardHeader = {
  backgroundColor: "rgb(230, 223, 223)",
  color: "rgb(112, 112, 112)",
  fontSize: ".9rem",
  fontWeight: "550",
  padding: ".2rem 1rem",
  borderTopLeftRadius: ".3rem",
  borderTopRightRadius: ".3rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  boxShadow: '0px 2px 4px #00000033'
};

export const CardInput = styled.div`
  margin: 1rem 0rem;

  @media(max-width: 770px) {
    margin: 1rem 0px;
  }
`;

export const CardInputItem = styled.div`
  margin: 1rem 0;
`;

export const CenterHeaderLabel= styled(SubTitle)`
  width: 100%;
  text-align: center;
  margin-bottom: 0px;

  @media (max-width: 770px) {
    margin-left: 0.2rem;
  }
`;

export const CenterHeaderQuantity = styled(SubTitle)`
  width: 100%;
  text-align: center;
  margin-top: 0px;

   @media (max-width: 770px) {
    margin-left: 0.2rem;
  }
`;

export const CenterItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: center;
  margin-bottom: 0rem;
`;

export const CloseIconStyled = styled.img`
  width: 10%;
  height: 10%;
  position: relative;
  cursor: pointer;

  @media (min-width: 420px) {
    width: 8%;
    height: 8%;
  }

  @media (min-width: 500px) {
    width: 6%;
    height: 6%;
  }

  @media (min-width: 1000px) {
    width: 28px;
    height: 28px;
    margin-top: 19px;
  }

  @media (max-width: 770px) {
    margin-left: 0.5rem;
  }
`;

export const ColAproveHeaderQuantity = styled.div`
  margin: 0px;
`;

export const ColAppliedHeaderQuantity = styled.div`
  text-align: center;
  margin: .5rem 0.2rem .5rem 0.3rem;
`;


export const InputApply = styled.input`
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  font-family: 'Roboto';
  text-align: center;
  background-color: #fff;
  border: 1px solid #b0b0b0;
  border-radius: 0.3rem;
  width: 100%;
  box-shadow: 0px 2px 2px #00000029;
`;

export const LabelProduct = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 0.3rem;
`;

export const LeftHeaderQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
`;

export const LeftItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  margin-bottom: 0rem;
`;

export const LefItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  margin-top: 1rem;
`;

export const LimitText = styled.div`
  @media (max-width: 280px) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 4rem;
  }
`;

export const LoadingIcon = styled.i`
  font-size: 18px;
`;

export const Product = styled.span`
  font-size: 1.1rem;
  color: ${() => infoColor};
  display: flex;
  justify-content: left;
`;

export const RightHeaderQuantity = styled(SubTitle)`
  width: 100%;
  text-align: right;

  @media (max-width: 700px) {
    width: 80%;
  }
  @media (max-width: 500px) {
    width: 60%;
  }
  @media (max-width: 310px) {
    width: 50%;
  }
`;

export const RightItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: right;
  margin-bottom: 0rem;

  @media (max-width: 700px) {
    text-align: right;
  }
`;

export const SubLeftItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  margin-top: 0rem;

  @media (max-width: 700px) {
    display: none;
  }
`;

export const SubLeftItemQuantityMobile = styled(SubTitle)`
  width: 100%;
  text-align: left;
  margin-top: 0rem;

  @media (min-width: 770px) {
    display: none;
  }

  @media (min-width: 770px) {
    display: none;
  }
`;

export const TextQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  margin-left: 1rem;
`;

export const Title = styled.h2`
  font-size: 1.1rem;
  font-weight: bold;
  color: ${() => grayColor};

  @media(min-width: 768px) {
    font-size: 1.2rem;
    margin: 1rem 0 1rem 0;
    display: flex;
    align-items: center;
  }
`;

export const TitlePage = styled.h1`
  color: white;
  font-size: 1.3rem;
  text-align: center;
  padding-top: 2rem;
  font-weight: 200;
  margin-bottom: -0.7rem;
  display: flex;
  justify-content: space-between;

  @media (min-width: 770px) {
    margin: 0 auto 0 auto;
    max-width: 762px;
  }

  img {
    @media (max-width: 770px) {
      margin-right: 1rem;
    }
  }
`;

export const ValueQuantity = styled(SubTitle)`
  text-align: right;
  font-weight: bold;
  margin-right: 1rem;
`;